/**
 * 결제 상태 표시 컴포넌트
 * 결제 상태를 시각적으로 표시하는 컴포넌트입니다.
 *
 * 주요 기능:
 * - 결제 상태에 따른 스타일 적용
 * - 계약 취소 상태 처리
 * - 상태별 레이블 표시
 */

import { searchStatusOption } from "src/api/billingSchedule/billing-type";
import { Select } from "src/api/public-types";

/**
 * 컴포넌트 속성 인터페이스
 * @property value - 결제 상태 값
 * @property contractStep - 계약 단계 (선택적)
 */
type ViewProps = {
  value: string;
  contractStep?: string;
};

/**
 * 결제 상태 표시 컴포넌트
 * 결제 상태에 따라 적절한 스타일과 텍스트를 표시합니다.
 *
 * @param value - 결제 상태 값
 * @param contractStep - 계약 단계
 * @returns 스타일이 적용된 결제 상태 표시 요소
 */
const PaymentStatusView = ({ value, contractStep }: ViewProps) => {
  let find = searchStatusOption.find((option: Select) => String(option.value) === value);
  if (!find) return null;
  if (find.value === "" && contractStep && contractStep === "APPLY_CANCEL") {
    find.label = "-";
  }
  if (find.label === "전체") {
    find.label = "-";
  }
  return <div className={`${find?.color}`}>{find.label}</div>;
};
export default PaymentStatusView;
